/**
 * Follow Next.js documentation for adding polyfills
 * https://nextjs.org/docs/app/api-reference/file-conventions/instrumentation-client#polyfills
 */
import './domain/polyfills'
